module.exports = __webpack_public_path__ + "static/babyboybanner-b875f1d8d53d7ede8e56d599ea855fc3.jpeg";